import { cn } from 'lib/utils';
import PropTypes from 'prop-types';

const Cell = ({ children, className, size }) => {
  return (
    <div
      className={cn(`col-span-6 md:col-span-3 xl:col-span-${size}`, className)}
    >
      {children}
    </div>
  );
};

Cell.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf([2, 3]).isRequired,
};

export default Cell;
